import { Base, Container, Grid, Parse, Section } from '@/components/Core'
import { Lib } from '@/types'
import { readFragment } from 'gql.tada'
import { memo } from 'react'
import SectionListFragment from './query'

export interface SectionListProps {
  data: Lib.FragmentOf<typeof SectionListFragment>
}

export type SectionListData = Lib.FragmentOf<typeof SectionListFragment> & {
  _modelApiKey: 'section_list'
  __typename: 'SectionListRecord'
  id: string
}

const SectionList = ({ data }: SectionListProps) => {
  const d = readFragment(SectionListFragment, data)

  return (
    <Section
      className={'py-vertical-main bg-neutral-300'}
      sectionName={d._modelApiKey}
      mainWrapper={false}
      anim="section-fade-in"
    >
      <Container>
        <Grid className="gap-y-vertical-main">
          <div className="col-span-12 lg:col-span-4 lg:col-start-2">
            <h2>{d.title}</h2>
          </div>
          {d?.text && (
            <div className={'text-style-large col-span-12 lg:col-span-6'}>
              <Parse html={d?.text} />
            </div>
          )}

          <div className="col-span-12 lg:col-span-10 lg:col-start-2">
            {d?.items &&
              d?.items.map((item, index) => (
                <Base
                  as="div"
                  anim="fade-in"
                  key={index}
                  className="py-vertical-small lg:py-2xl gap-md flex flex-col border-b border-neutral-500"
                >
                  <h4>{item.title}</h4>
                  {item?.text && (
                    <div
                      className="text-neutral-600 lg:max-w-1/2"
                      dangerouslySetInnerHTML={{ __html: item?.text }}
                    ></div>
                  )}
                </Base>
              ))}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectionList)
